import imageUrlBuilder from '@sanity/image-url'
import {env} from '~/config/env.mjs'

const sanityProjectId = env.NEXT_PUBLIC_MERCURY_WEB_SANITY_PROJECT_ID

// eslint-disable-next-line import/no-unused-modules
export const imageBuilder = imageUrlBuilder({
  projectId: sanityProjectId,
  // dataset: env.NEXT_PUBLIC_BACKEND_SOURCE === 'production' ? 'mwb' : 'dev',
  dataset: 'mwb',
})

// eslint-disable-next-line import/no-unused-modules
export const imageUrlFor = (source: string) =>
  imageBuilder.image(source).auto('format')
